module.exports = __webpack_public_path__ + "92ca4671bbf7eebd958adc9cf60937cc.jpg";